module.exports = new __parcel__URL__("paper-aeroplane.83d00122.svg").toString();